export default {
  methods: {
    formatPrice (value) {
      return Math.round(value / 1000 * 10).toFixed(2)
    }
  }
}
